import { render, staticRenderFns } from "./FormPortfolio.vue?vue&type=template&id=0ca9c298&lang=pug&"
import script from "./FormPortfolio.vue?vue&type=script&lang=js&"
export * from "./FormPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports